// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { styled } from '@mui/material/styles';
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { KeyboardArrowUpIcon } from '../icons';

const Arrow = styled(KeyboardArrowUpIcon, { shouldForwardProp: (prop) => prop !== 'up' && prop !== 'sx' })<{
  readonly up: boolean;
}>(({ theme, up }) => ({
  // color: theme.custom.colors.common.white,
  transition: theme.transitions.create(['transform']),
  transform: up ? 'rotate(180deg)' : 'rotate(0deg)',
  cursor: 'pointer',
}));

interface Props {
  up: boolean;
}
export default function Chevron({ up }: Props): React.ReactElement {
  return <Arrow up={up} />;
}
